import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rValue } from '../../models/.catalog';
import { rGrupSirketDegerlemeUstBilgi } from '../../models/rGrupSirketDegerlemeUstBilgi';

export default class GrupSirketDegerlemeUstBilgi extends ApiBase<
  pList,
  rValue<rGrupSirketDegerlemeUstBilgi>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/GrupSirketDegerlemeUstBilgi',
      }),
      options
    );
  }
}
